// Single source of truth for the proof-of-work worker.
// `npm run pow-build` compiles + minifies this file and embeds it as a string
// into src/components/trustcaptcha-component/src/pow/pow-worker-script.ts.

interface ChallengeTask {
  number: number;
  input: string;
}

interface TaskMessage {
  type: 'task';
  taskId: number;
  task: ChallengeTask;
  difficulty: number;
}

const encoder = new TextEncoder();

self.addEventListener('message', async (event: MessageEvent<TaskMessage>) => {
  const data = event.data;
  if (!data || data.type !== 'task') return;
  const nonce = await solve(data.task.input, data.difficulty);
  postMessage({ type: 'result', taskId: data.taskId, result: { number: data.task.number, nonce } });
});

async function solve(inputBase64: string, difficulty: number): Promise<string> {
  const inputBytes = base64ToBytes(inputBase64);
  const buffer = new Uint8Array(inputBytes.length + 32);
  buffer.set(inputBytes, 0);
  const nonceOffset = inputBytes.length;

  for (let nonce = 0; ; nonce++) {
    const nonceStr = 'tcn' + nonce;
    const nonceBytes = encoder.encode(nonceStr);
    buffer.set(nonceBytes, nonceOffset);
    const message = buffer.subarray(0, nonceOffset + nonceBytes.length);
    const hash = new Uint8Array(await crypto.subtle.digest('SHA-256', message));
    if (countLeadingZeroBits(hash) >= difficulty) {
      return nonceStr;
    }
  }
}

function base64ToBytes(b64: string): Uint8Array {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

function countLeadingZeroBits(bytes: Uint8Array): number {
  let count = 0;
  for (let i = 0; i < bytes.length; i++) {
    const byte = bytes[i];
    if (byte === 0) {
      count += 8;
    } else {
      count += Math.clz32(byte) - 24;
      break;
    }
  }
  return count;
}
